/** @jsxImportSource @emotion/react */

import useStyles from './styles';

const CFAOpenFiltersMSG = ({
  filterShowHide,
  setFilterShowHide,
  isMapPage,
}) => {
  const styles = useStyles();
  return (
    <div css={styles.CFAOpenFiltersMSGCont(isMapPage)}>
      <h3 css={styles.CFAOFTitle}>Oops, we couldn't find anything</h3>
      <p css={styles.CFAOFSubTitle}>
        Try expanding your filters or using a different location
      </p>
      <button
        css={styles.CFAOFButton(isMapPage)}
        onClick={() => setFilterShowHide(prev => !prev)}
      >
        {filterShowHide ? 'Close' : 'Open'} Filters
      </button>
    </div>
  );
};

export default CFAOpenFiltersMSG;
